import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import "../../Assets/Styles/pages/landing.scss";
import { useTranslation } from "react-i18next";
import ContactUsModal from "../ContactUsModal/contactUsModal";
import ButtonRounded from "../Signature/button";

const ContactUs = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Row className="m-0 faqFooter w-100 d-flex justify-content-center ">
      <Row className=" text-center d-flex justify-content-center align-items-center text_40 productSansBold">
        <Col md={12}>
          {t("ContactUs")}
          <span className="mx-2 landing_banner_Heading">
            {t("ContactUsSpan")}
          </span>
          <p className="p-0 m-0 text_16 text-center productSans">
            {t("ContactUsSubTitle")}
          </p>
          <ButtonRounded
            onclick={() => {
              setOpen(true);
            }}
            text={"Contact us"} // Use translated text
            style={
              "w_max contactUsButton Aktiv px-5 py-2 mt-3 text_18 m-0 donebutton button_text_signin"
            }
          />
          {/* <button
                        onClick={() => {
                            setOpen(true)
                        }}
                        className={`contactUsButton Aktiv border-0 button_text px-5 py-2 Aktiv text_18 m-0 donebutton button_text_signin`}>
                        {t("Contact us")}
                    </button> */}
        </Col>
      </Row>
      <ContactUsModal open={open} setOpen={setOpen} />
    </Row>
  );
};

export default ContactUs;
